module.exports = __webpack_public_path__ + "static/media/emina_logo_big.87c964f9.png";